
import React, { useEffect, useState } from "react";
import { pdf } from '@react-pdf/renderer';
import { useParams } from 'react-router-dom';
import { Page, Text, View, Document, StyleSheet, Font, Image} from '@react-pdf/renderer';
import UserService from "../../controllers/UserService";
import AuthService from "../../controllers/AuthService";
import strengths from "../../files/strengths.json";
import $ from 'jquery'
Font.register('/font/Sarabun-Regular.ttf', { family: 'SarabunRegular' } );
Font.register('/font/Sarabun-Bold.ttf', { family: 'SarabunBold' } );


function PdfFile() {
    const { activityId, keyType,code, studentId } = useParams();

    const [headerText, setHeaderText] = useState('กิจกรรม Homeroom');
    const [userFullName, setUserFullName] = useState(AuthService.getUserFullName());
    const [role, setRole] = useState(AuthService.getUserRole());
    const [userId, setUserId] = useState(AuthService.getCurrentUserId());
    let teacher = '';
    let answers1 = [];
    let answers2 = [];
    let attenders = 0;
    let maxStudent = 0;
    let title = '';
    let activityQuestions = [];
    let teacherAnswer = '';
    let imageUrl = '';
    let answersPercent1 = [];
    let answersPercent2 = [];    
    let per1 = [];
    let per11 = [];
    let ans1 = [];
    let ans11 = [];
    let otherPercent = 0;
    let content = '';    
    const regex = /(<([^>]+)>)/ig; 
    const regex1 = /\&nbsp;/g;
    const regex2 = /  +/g;
    // const regex3 = /[\uE000-\uF8FF]/g;  202F
    const regex3 = /[\u202F]/g;
    // const regex3 = /\ /g;
    const regex4 = /\ /g;
    let school = null;
    let logo = UserService.getLogoUrl();  
    let answer = [];
    let answer1 = '';
    let answer2 = '';  
    let room = null;
    let dateString = '';
    let student = '';
    let content2 = [];
    
    const processContent = (ctx) => {       
        if( ctx !== undefined ){
            // ctx = ctx.replace(/<img[^>]*>/g,"");
            ctx = ctx.replace(regex, ' ');
            ctx = ctx.replace(regex1, ' ');  
            ctx = ctx.replace(regex2, ' ');  
            ctx = ctx.replace(regex3, ' ');  
            ctx = ctx.replace(regex4, ' '); 
            try {
                ctx = decodeURI(ctx);
            }
            catch(err) {}
        } else {
            ctx = '';
        }
        
        let tempPlusStart = 0;
        let result = []
        var start = 0;
        // let limit = 82;
        let limit = 70;
        for(let i = 0; i <= ((ctx.length)/limit+1); i++){
            // find last char                      
            
            var length = start+limit;       

            var tempString = ctx.slice(start, length);
            var focusVowls = (tempString.match( /["่","้","๋","๊","็","ั","ี","ึ","ื","ิ","ุ","ู","์","ั"]/g) || []).length;
            // console.log(tempString,focusVowls);
            length = length+(focusVowls);            

            var pre =  ctx[length-2]; 
            var last =  ctx[length-1]; 
            var next = ctx[length]; 
           
         
            // start += tempPlusStart;
      
            tempPlusStart = 0;
     

            var vowels  = ["า", "ำ", "ะ","่","้","๋","๊","็","ั", " ","ี","ึ","ื","ิ","ุ","ู","์"];
            var vowels2  = ["เ", "ไ", "ใ", "แ","ั"," "];
            
            var result1 = vowels.includes(last);
            var result2 = vowels2.includes(last);

            var result3 = vowels.includes(next);
            var result4 = vowels2.includes(pre);
            // console.log(pre,last,next,result1,result2,result3);
            if(result3){
                //next is ["า", "ำ", "ะ","่","้","๋","๊","็","ั", " "];    
                if(next !== ' '){
                    // console.log('44444444444');
                    length -= 1;
                    tempPlusStart-= 1;
                    if(!(/^[ก-ฮa-zA-Z]+$/ig.test(last))){ 
                        // console.log('55555555555555');
                        length -= 1;
                        tempPlusStart-= 1;                        
                    }

                    if(result4){ 
                        // console.log('6666666');
                        length -= 1;
                        tempPlusStart-= 1;
                        
                    }
                }            
               
            } else if( !(/^[ก-ฮa-zA-Z]+$/ig.test(last)) && !result1){
                //check should plus or minus          
                if(result2){
                    // vowels2
                    // console.log('1111111111');
                    length -= 1;
                    tempPlusStart-= 1;
                    // if(!(/^[ก-ฮa-zA-Z]+$/ig.test(pre))){ 
                    //     length -= 1;
                    //     tempPlusStart-= 1;
                    // }
                } else {
                    if(!(/^[ก-ฮa-zA-Z]+$/ig.test(next)) && !result3) {
                        // console.log('2222222222');
                        length -= 1;
                        tempPlusStart-= 1;
                    } else {
                        // console.log('33333333333');
                        length += 1;
                        tempPlusStart+= 1;
                    }
                }


            }
          
            result.push(ctx.slice(start, length) + " ");     
            start =+ length; 
            // console.log('--------------------------------------');                         

        }
        return (result.join('\n')).trim();
    }

    const processContent2 = (ctx, contentType = null) => {
          var limit = 79;
          var notLessThan = 75;       
          ctx = ctx.replace(regex, ' ');
          ctx = ctx.replace(regex1, ' ');     
        return ctx;
        //   var allContent =  ctx.trim().split(/\s+/);
           var allContentCurrent =  ctx.trim().split(" ");
           var allContent = [];
           console.log(allContent);
           var dataReturn = []; 
           var tempData = '';
           var tempTest = '';
           var countIndex = 0;
        
           for(var i=0; i<allContentCurrent.length; i++){    
               if(allContentCurrent[i].length > limit){           
                    var t1 = allContentCurrent[i].slice(0, limit);
                    var t2 =  allContentCurrent[i].slice(limit, allContentCurrent[i].length);
                    allContentCurrent[i] = t1;
                    allContentCurrent.splice(i+1, 0, t2);

               } else {
                   if( allContentCurrent[i].length > 0){
                        allContent[countIndex] = " " + allContentCurrent[i];
                        countIndex++;
                   }
                
               }
           }
  
           var countT = 0;
           for(var i=0; i < allContent.length; i++){   
          
                //curent lenght more than limit     
                tempTest +=  allContent[i];               
                if(tempTest.length < limit ){
                    tempData =  tempTest;
                    if(i == allContent.length-1){
                        dataReturn.push(tempData);   
                    }
                } else {
                    if(tempData.length < notLessThan ){
                        //need some text from next array 
                        var currentLength = tempData.length;
                        var needCount  = limit - currentLength;                                 
                                                               
                        var count = 0;
                        var status = true;
                        while (status) {
                            var lastPrevious =  allContent[i][needCount+count-1];      
                            var last =  allContent[i][needCount+count];       
                            var lastNext =  allContent[i][needCount+count+1];                       
                            console.log(lastPrevious, last, lastNext);

                            var vowels  = ["า", "ำ", "ะ"];
                            var vowels2  = ["เ", "ไ", "ใ", "แ"];
                            
                            var result = vowels.includes(last);
                            var result2 = vowels2.includes(vowels2);
                         
                            console.log(!result);
                            if(  (  !(/^[ก-ฮa-zA-Z]+$/ig.test(last)) && !result  ) || (!(/^[ก-ฮa-zA-Z]+$/ig.test(lastNext)) && !result2 ) ){
                            
                                count--;   
                                
                                if(lastPrevious === 'ั'){
                                    console.log('ไม่หันอากาศ');
                                    count--;   
                                }                                
                                
                            } else {
                                status = false;
                            }
                           

                          }
                          console.log('------------------------------');
                        
                        var t1 =  allContent[i].slice(0, needCount+count+1);
                        var t2 =  allContent[i].slice(needCount+count+1, allContent[i].length);
                
                        tempData  = tempData + t1;
                        allContent[i] = t2;

                    } 
                    if(tempData == ''){
                        console.log(countT);
                        countT++;
                    }                    
                    dataReturn.push(tempData);   
                    tempTest =  allContent[i];
                    tempData = allContent[i];        
                    if(i == allContent.length-1){
                        dataReturn.push(allContent[i]);   
                    }                       
                }
           }          
           console.log(dataReturn);
           return dataReturn.join('\n')
        // if(contentType === null){
        //     return dataReturn.join('\n')
        // } else {
        //    var tempContent = dataReturn.map(function(p, i){
        //         // p = String(p.trim());               
        //         return (
        //             <View style={styles.divRow}>                        
        //                 <Text style={styles.width100NormalText}>{p}</Text>
        //             </View>
        //             );
        //     });    

        //     return tempContent;
        // }   
       
    }

  
    useEffect(() => {
        UserService.getUserAndDomain(userId).then((res) => {
            school = res.data.data.domain.displayName;
            //logo =  '/images/school/'+ res.data.data.domain.id + '_' +res.data.data.domain.name +'.png';
            logo = UserService.getLogoUrl();  

            if (keyType === 'overview') {
                UserService.getActivityDetail(activityId)
                .then((res) => {
                    // console.log(res);
                    // console.log('res.data.data.createdBy.fullName')
                    // console.log(res.data.data.createdBy.fullName)
                    teacher = res.data.data.createdBy.fullName
                    var questions = [
                        processContent(res.data.data.topic.questions[0].content),
                        processContent(res.data.data.topic.questions[1].content),
                        processContent(res.data.data.topic.questions[2].content),
                    ]
                    // console.log(res.data.data.topic.content);
                    activityQuestions = questions;
                    // console.log(activityQuestions);
                    title = res.data.data.topic.title;
                    maxStudent = res.data.data.maxStudent;
                    teacherAnswer = processContent(res.data.data.comment);
                    content = res.data.data.topic.content;                     
                    console.log(content);
                    content2 = processContent(content)
                    console.log(content2);
                    imageUrl = res.data.data.topic.imageUrl + '?ver=1';
                    console.log(imageUrl);
                  
                    if (res.data && res.data.data && res.data.data.attenders) {
                        attenders = res.data.data.attenders.length;
                    } else {
                        attenders = 0;
                    }   
                    
                    return res;
                }).then((res1)=> {
                    UserService.getAnswersPercent(activityId, res1.data.data.topic.questions[0].id).then((res) => {
        
                        var dateTemp = new Date(res1.data.data.createdAt.year+'-'+res1.data.data.createdAt.monthValue+'-'+res1.data.data.createdAt.dayOfMonth);
                        dateString = gendate(dateTemp);         

                        // var percent = [];
                        var tempPercent = 0;
                        var stringHtml;
                        // console.log(res.data.data.percentages);
        
                        var myArr = Object.fromEntries(
                            Object.entries(res.data.data.percentages).sort(([, a], [, b]) => b - a)
                        );
        
                        // console.log(myArr);
                        // console.log(strengths);    
        
                        Object.keys(myArr).map((aArray, i) => {
                            tempPercent = parseFloat(res.data.data.percentages[aArray])
                            stringHtml = `<div key="${i}" class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100" /><br>${tempPercent.toFixed(2)}%</div>`;
                            var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap" />
                            if(i <= 2){
                                var data = {
                                    'imagePath': "/images/strengths/cards/" + aArray + '.png',
                                    'score': tempPercent.toFixed(2),
                                };
                                answersPercent1.push(data);
                            } else if (i <= 5) {
                                var tempName = strengths.filter(function (strength) { return strength.value === aArray });
                                
                                var data = {
                                    'name': tempName[0] !== undefined ? tempName[0].title : '-',
                                    'score': tempPercent !== undefined ? tempPercent.toFixed(2) : '0',
                                };                            
                                answersPercent2.push(data);
                            } else {
                                otherPercent = (parseFloat(otherPercent) + parseFloat(tempPercent)).toFixed(2);
                                
                            }     
                        })                    
                    
                        if(otherPercent > 0){
                            var data = {
                                'name': 'อื่นๆ',
                                'score': otherPercent,
                            }; 
                            answersPercent2.push(data);

                        }

                        answersPercent1.map(function(p, i){
                            per1.push(
                                <View style={styles.width33}>
                                    <Image style={styles.image2} src={p.imagePath} />                                
                                </View>   
                                );

                            per11.push  (
                                <View style={styles.width33}>
                                    <Text style={styles.T16Center}>{p.score}%</Text>                    
                                </View>   
                                );  
                        });                             

                        answersPercent2.map(function(p, i){
                            ans1.push(<Text style={styles.T14Left}>• {p.name}</Text>);
                            ans11.push( <Text style={styles.T14RightBold}>{p.score}%</Text>);    
                        });          
                    
                        
                        return res1;
        
                    }).then((res2)=> {
                        var ans = [];
                        UserService.getAnswers(activityId, res2.data.data.topic.questions[1].id).then((res) => {    
                            for (const [index, value] of res.data.data.entries()) {                       
                                ans.push(processContent(value.answer));                      
                            }             
                            answers1 = ans.map(function(p, i){
                                return (
                                        <View style={styles.ansBox} wrap={false}>
                                        <Text style={styles.normalText}>{p}</Text>
                                        </View>
                                    );
                            });     
                            return res2;
                        }).then((res3)=> {
                            UserService.getAnswers(activityId, res3.data.data.topic.questions[2].id).then((res) => {     
                                var ans = [];              
                                for (const [index, value] of res.data.data.entries()) {                       
                                    ans.push(processContent(value.answer));           
                                }

                                answers2 = ans.map(function(p, i){
                                    return (
                                        <View style={styles.ansBox} wrap={false}>
                                        <Text style={styles.normalText}>{p}</Text>
                                        </View>
                                        );
                                });    
                                return res3;
                            }).then((res4) => {
                                UserService.getStudentInRoom(res4.data.data.roomId).then((res) => {
                                        room =  res.data.data.displayName;                                                                                
                                    }).then(async () => {
                                        await savePdf(MyDocument(), "overview_room"+room.replace(/ม.|ป.| /g, '_')+".pdf");
                                        setTimeout(() => {window.close(); }, 2000)
                                    });         
                            })
                        })
                    })                      
                })
            
            } else if (keyType === 'person') {
                
                UserService.getActivityDetail(activityId).then((res) => {
                    content = res.data.data.topic.content;     
                    // console.log(content);               
                    content = processContent(content)
                    // console.log(content);
                 
                    teacher = res.data.data.createdBy.fullName
                    imageUrl = res.data.data.topic.imageUrl + '?ver=1';
                    // console.log(imageUrl);

                    var dateTemp = new Date(res.data.data.createdAt.year+'-'+res.data.data.createdAt.monthValue+'-'+res.data.data.createdAt.dayOfMonth);
                    dateString = gendate(dateTemp);         

                    var questions = [
                        processContent(res.data.data.topic.questions[0].content),
                        processContent(res.data.data.topic.questions[1].content),
                        processContent(res.data.data.topic.questions[2].content),
                    ]
                    activityQuestions = questions;
                    maxStudent = res.data.data.maxStudent;
                    title = res.data.data.topic.title;
                    if (res.data && res.data.data && res.data.data.attenders) {
                        attenders = res.data.data.attenders.length;
                    } else {
                        attenders = 0;
                    }       
                    return res;
                }).then((res1) => {                    
        
                    UserService.getAnswersByStudentId(activityId, res1.data.data.topic.questions[0].id, studentId).then((res) => {
        
                        if (res && res.answer) {
                            // console.log(res.answer);
                            var path = [
                                `/images/strengths/cards/${res.answer[0]}.png`,
                                `/images/strengths/cards/${res.answer[1]}.png`,
                                `/images/strengths/cards/${res.answer[2]}.png`,
                            ];
                            answer = path;
                        }
                        return res1;
                    }).then((res2) => {
        
                        UserService.getAnswersByStudentId(activityId, res2.data.data.topic.questions[1].id, studentId).then((res) => {
                            if (res && res.answer) {
                                answer1 = processContent(res.answer);
                            }
                            return res2;
                        }).then((res3) => {
                            UserService.getAnswersByStudentId(activityId, res3.data.data.topic.questions[2].id, studentId).then((res) => {
                                if (res && res.answer) {
                                    answer2 = processContent(res.answer);
                                }
                                return res3;
                            }).then((res4) => {
                                UserService.getStudentInRoom(res4.data.data.roomId).then((res) => {
                                        room =  res.data.data.displayName;                                        
                                    }).then(() => {
                                        UserService.getUserAndDomain(studentId).then((res) => {                                          
                                            student = res.data.data.fullName;
                                        }).then(async () => {
                                            let fileName =  student.replace(/ /g, '_')+'_homeroom_room'+room.replace(/ม.|ป.| /g, '_');
                                            await savePdf(StudentReport(), fileName+".pdf");
                                            setTimeout(() => {window.close(); }, 2000)
                                        });  
                                    })                              
                            })
                        })
                    }) 
                })                
            }
        })    
        
    }, []);

    const StudentReport = () => {
        return (
            <Document>
                <Page size="A4" style={styles.page} wrap>      
                {/* <View style={styles.header} fixed>           
                    <View style={styles.headerLeft}>               
                            <View style={styles.logo}>
                                <Image style={styles.image} src={logo} />                                
                            </View>       
                            <View style={styles.THL}>  
                                <Text style={styles.HLB}>{school}</Text>                         
                                <Text style={styles.HLR}>สรุปกิจกรรม : {dateString} ครูประจำชั้น : {teacher}</Text>
                            </View>                   
                    </View>           
                    <View style={styles.headerRight}>
                        <Text style={styles.HLB}>{headerText} {room}</Text>
                        <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>            
                    </View>            
                </View> */}

                <View style={styles.header100} fixed>               
                        <View style={styles.logo1}>
                            <Image style={styles.image} src={logo} />                                
                        </View>      
                    <View style={styles.THL1}>  
                            <Text style={styles.HLB}>{school}</Text>                         
                            <Text style={styles.HLR}>สรุปกิจกรรม : {dateString} ครูประจำชั้น : {teacher}</Text>
                    </View>          
                    <View style={styles.THL2}>
                        <Text style={styles.HLB}>{headerText} {room}</Text>
                        <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>             
                    </View>         
                </View>    
                
                <View style={styles.divRow} fixed>
                    <View style={styles.headerLeft}>
                        <Text style={styles.textBlue}>รายงานของ : {student}</Text>    
                    </View>
                    <View style={styles.boxRight}>       
                            <View style={styles.icon1}>                              
                            </View>       
                            <View style={styles.width50}>   
                                <Text style={styles.textBlue}></Text>                        
                            </View>         
                    </View>
                </View>   
                
                {(code === 'story' || code === 'all') && (
                <View>
                    <View style={styles.divRow} breaks>
                        <Text style={styles.titleCenter}>{title}</Text>
                    </View>

                    {(imageUrl !== '') && (
                    <View style={styles.divRow}> 
                        <View style={styles.width100}>
                            <Image style={styles.image3} src={ imageUrl } allowDangerousPaths={true} />                                
                        </View> 
                    </View>
                    )}
                    
                    <View style={styles.divRow}>
                        <Text  style={styles.width100NormalText}>{content}</Text>
                    </View>
                </View>                
                )}

                {(code === 'all') && (
                    <Text break />
                )}

                {(code === 'answer' || code === 'all') && (
                <View>
                    <View wrap>
                        <View style={styles.divRow} breaks>
                            <Text style={styles.titleCenter}>{title}</Text>
                        </View>
                        <View style={styles.divRow}>  
                            <Text style={styles.subTitleCenter}>เลือกตอบ 3 คุณค่าจากนิสัยเชิงบวก (3/3)</Text>
                        </View>
            
                        <View style={styles.divRow}> 
                            <Text style={styles.width100NormalText}>{activityQuestions[0]}</Text>
                        </View>
                    </View>       
                    <View style={styles.divRow}>                           
                        <View style={styles.width33}>
                            <Image style={styles.image2} src={answer[0]} />                                
                        </View> 
                        <View style={styles.width33}>
                            <Image style={styles.image2} src={answer[1]} />                                
                        </View> 
                        <View style={styles.width33}>
                            <Image style={styles.image2} src={answer[2]} />                                
                        </View> 
                    </View>              
        
                    <View wrap={false}>
                    <View style={styles.divRow}>
                        <Text style={styles.subTitleCenter}>มุมมองของนักเรียนที่มีต่อเรื่องราวนี้</Text>
                    </View>           
                    <View style={styles.divRow}> 
                        <Text style={styles.width100NormalText}>{activityQuestions[1]}</Text>
                    </View>
                    </View>
                        
                    <View style={styles.ansBox} wrap={false}>
                        <Text style={styles.normalText}>{answer1}</Text>
                    </View>       
                
                    <View wrap={false}>
                    <View style={styles.divRow}>
                        <Text style={styles.subTitleCenter}>แรงบันดาลใจที่ได้รับจากเรื่องราว</Text>
                    </View>   
                    <View style={styles.divRow}> 
                        <Text style={styles.width100NormalText}>{activityQuestions[2]}</Text>
                    </View>
                    </View>
                                
                    <View style={styles.ansBox} wrap={false}>
                        <Text style={styles.normalText}>{answer2}</Text>
                    </View>
                </View>
                )}

                <View style={styles.footer} fixed>   
                    <View style={styles.headerLeft}>               
                        <Text style={styles.footerTextL} >ออกโดยบริษัท MINDSET MAKER CO., LTD.</Text>            
                    </View>           
                    <View style={styles.headerRight}>
                        <Text style={styles.footerTextR} render={({ pageNumber, totalPages }) => (
                            `หน้า : ${pageNumber}/${totalPages}`
                        )} fixed />       
                    </View>    
                </View>
                </Page>
            </Document>
            )
    }

    const gendate = (dateTime) => {     
        // console(formattedDate, formattedMonth);
        var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
        var temp = dateTime.getFullYear() + 543;
        return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
    }

    const MyDocument = () => {
        return (
            <Document>
                <Page size="A4" style={styles.page} wrap>      
                {/* <View style={styles.header} fixed>           
                    <View style={styles.headerLeft}>               
                            <View style={styles.logo}>
                                <Image style={styles.image} src={logo} />                                
                            </View>       
                            <View style={styles.THL}>  
                                <Text style={styles.HLB}>{school}</Text>                         
                                <Text style={styles.HLR}>สรุปกิจกรรม : {dateString} ครูประจำชั้น : {teacher}</Text>
                            </View>                   
                    </View>           
                    <View style={styles.headerRight}>
                        <Text style={styles.HLB}>{headerText} {room}</Text>
                        <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>            
                    </View>            
                </View> */}

                <View style={styles.header100} fixed>               
                        <View style={styles.logo1}>
                            <Image style={styles.image} src={logo} />                                
                        </View>      
                    <View style={styles.THL1}>  
                            <Text style={styles.HLB}>{school}</Text>                         
                            <Text style={styles.HLR}>สรุปกิจกรรม : {dateString} ครูประจำชั้น : {teacher}</Text>
                    </View>          
                    <View style={styles.THL2}>
                        <Text style={styles.HLB}>{headerText} {room}</Text>
                        <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>             
                    </View>         
                </View>    

                <View style={styles.divRow} fixed>
                    <View style={styles.headerLeft}>
                        <Text style={styles.textBlue}>รายงานของ : ห้อง {room}</Text>    
                    </View>
                    <View style={styles.boxRight}>       
                            <View style={styles.icon1}>
                                <Image style={styles.image} src="/images/school/frame.png" />                                
                            </View>       
                            <View style={styles.width50}>   
                                <Text style={styles.textBlue}>จำนวนนักเรียน {attenders}/{maxStudent}</Text>                        
                            </View>         
                    </View>
                </View>   
        
                {/* story  and both*/}
                {(code === 'story' || code === 'all') && (
                    <View>
                        <View style={styles.divRow} breaks>
                            <Text style={styles.titleCenter}>{title}</Text>
                        </View>
                        {(imageUrl !== '') && (
                            <View style={styles.divRow}> 
                                <View style={styles.width100}>
                                    <Image style={styles.image3} src={ imageUrl } allowDangerousPaths={true} />                                
                                </View> 
                            </View>
                        )}

                        <View style={styles.divRow}>
                            <Text style={styles.width100NormalText}>{content2}</Text>
                        </View>
                    </View>
                )}

                {/*both*/}
                {(code === 'all') && (
                    <Text break />
                )} 

                {/* answer  and both*/}

                {(code === 'answer' || code === 'all') && (
                <View>
                    <View wrap>
                        <View style={styles.divRow} breaks>
                            <Text style={styles.titleCenter}>{title}</Text>
                        </View>
                        <View style={styles.divRow}>  
                            <Text style={styles.subTitleCenter}>เลือกตอบ 3 คุณค่าจากนิสัยเชิงบวก (3/3)</Text>
                        </View>
            
                        <View style={styles.divRow}> 
                            <Text style={styles.width100NormalText}>{activityQuestions[0]}</Text>
                        </View>
                    </View> 

                    <View style={styles.divRow}>                           
                        {per1}
                    </View>
                    <View style={styles.divRow}>                    
                        {per11}
                    </View>
                    {(ans1.length > 0) && (
                        <View style={styles.divRowBoxBlue} wrap={false}> 
                            <View style={styles.boxLeftBlock}>  
                                {ans1}
                            </View>
                            <View style={styles.boxRightBlock}>                        
                                {ans11}
                            </View>
                        </View>
                    )}            
        
                    <View wrap={false}>
                    <View style={styles.divRow}>
                        <Text style={styles.subTitleCenter}>มุมมองของนักเรียนที่มีต่อเรื่องราวนี้</Text>
                    </View>           
                    <View style={styles.divRow}> 
                        <Text style={styles.width100NormalText}>{activityQuestions[1]}</Text>
                    </View>
                    </View>
                        
                    {answers1}             
                
                    <View wrap={false}>
                    <View style={styles.divRow}>
                        <Text style={styles.subTitleCenter}>แรงบันดาลใจที่ได้รับจากเรื่องราว</Text>
                    </View>   
                    <View style={styles.divRow}> 
                        <Text style={styles.width100NormalText}>{activityQuestions[2]}</Text>
                    </View>
                    </View>
                                
                    {answers2}  

                    <View wrap={false}>
                    <View style={styles.divRow}>
                        <Text style={styles.subTitleCenter}>ความคิด และความรู้สึกของครู</Text>
                    </View>   
                    <View style={styles.divRow}> 
                        <Text style={styles.width100NormalText}>เมื่อได้อ่านมุมมองของนักเรียนที่มีต่อเรื่องราวในวันนี้ ชวนคุณครูบันทึก ความคิด และความรู้สึก ที่เกิดขึ้นเพื่อสะท้อนคิดเรียนรู้ และเติบโตไปพร้อมกัน</Text>
                    </View>
                    </View>

                    <View style={styles.ansBox} wrap={false}>
                        <Text style={styles.normalText}>{teacherAnswer}</Text>
                    </View>
                </View>    
                )}
    

                <View style={styles.footer} fixed>   
                    <View style={styles.headerLeft}>               
                        <Text style={styles.footerTextL} >ออกโดยบริษัท MINDSET MAKER CO., LTD.</Text>            
                    </View>           
                    <View style={styles.headerRight}>
                        <Text style={styles.footerTextR} render={({ pageNumber, totalPages }) => (
                            `หน้า : ${pageNumber}/${totalPages}`
                        )} fixed />       
                    </View>    
                </View>
                </Page>
    
            </Document>
        )
    }

    return ''
};


const saveBlob = (blob, filename) => {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style.display = "none";
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
};


const savePdf = async (document, filename) => {
    saveBlob(await pdf(document).toBlob(), filename);
};

const styles = StyleSheet.create({
   
    page: {       
        paddingBottom: 30
    },
    footer: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 10,          
      display: 'flex',
      flexDirection: 'row',  
    },

    footerTextR: { 
        textAlign: 'right',
        fontSize: 10,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        color: '#828282',
    },

    footerTextL: { 
        textAlign: 'left',
        fontSize: 10,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        color: '#828282',
    },

    header: {
        borderBottomWidth: 1,
        borderBottomColor: '#C4C4C4',
        color: '#000000',
        margin: 30,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,
    },
    headerLeft: {
        textAlign: 'left',
        flex: 1,
        alignSelf: 'center',     
        display: 'flex',
        flexDirection: 'row',
      
    },
    headerRight: {
        textAlign: 'right',
        flex: 1,
    
    },  
    HLB: {
        fontSize: 14,
        fontWeight: 900,
        lineHeight: 1.5,
        color: '#000000',
        fontFamily: 'SarabunBold',   
    },
    HLR: {
        fontSize: 10,
        lineHeight: 1.5,
        color: '#000000',
        fontFamily: 'SarabunRegular',   
    },
    image: {
        width: "100%",      
    },
    logo: {
        paddingRight: 5,
        width: "15%",
    },
    THL: {
     width: "85%",
    },   
    header100: {
        borderBottomWidth: 1,
        borderBottomColor: '#C4C4C4',
        color: '#000000',
        margin: 30,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,         
    },
    logo1: {
        paddingRight: 5,
        width: "7%",
    },
    THL1: {
     width: "60%",
    },  
    THL2: {
        textAlign: 'right',
        width: "33%",
    },
    tableRowWhite: {
        padding: 10,
        display: 'block',
        flexDirection: 'row',    
    },
    divRow: {
        color: '#000000',
        padding: 30,
        paddingBottom: 5,
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'row',
        // overflowWrap: 'anywhere',
        // whiteSpace: 'break-spaces',
    },
    textBlue: {
        fontSize: 14,
        color: '#3765D1',
        lineHeight: 1.5,       
        fontFamily: 'SarabunRegular',       

    },
    boxLeft: {
        textAlign: 'left',
        flex: 1,
        alignSelf: 'left',     
        display: 'flex',
        flexDirection: 'row',
    },
    boxRight: {
        textAlign: 'right',
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'right',
    },
    icon1: {
        marginLeft: 100,
        paddingRight: 0,
        width: "10%",        
    },
    width45: {
        width: "45%", 
        textAlign: 'right',       
    },
    width50: {
        width: "50%", 
        textAlign: 'right',       
    },
    titleCenter: {
        textAlign: 'center',
        fontSize: 16,
        fontFamily: 'SarabunBold',
        paddingBottom: 10,
        paddingTop: 10,
        lineHeight: 1.5,
    },
    subTitleCenter: {
        textAlign: 'center',
        fontSize: 14,
        color: '#3765D1',
        fontFamily: 'SarabunBold',   
        paddingTop: 10,
        lineHeight: 1.5,
    },
    normalText: {
        color: '#000000',
        fontSize: 14,
        fontFamily: 'SarabunRegular',  
        lineHeight: 1.5,
    },
    normalTextCenter: {
        color: '#000000',
        fontSize: 14,
        fontFamily: 'SarabunRegular',  
        textAlign: 'center',
        lineHeight: 1.5,
    },
    width100NormalText: {
        color: '#000000',
        fontSize: 14,
        fontFamily: 'SarabunRegular',  
        width: "100%",
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        // textAlign: 'justify',
        overflowWrap: 'anywhere',
        whiteSpace: 'break-spaces',
    },
    width33: {
        width: "33.33%",
    },
    width100: {
        width: "100%"
    },
    image2: {
        width: "90%",      
        border: 1,
        borderColor: '#000000',
        margin: 10,
        marginBottom: 0,
        borderRadius: '12'
    },
    T16Center: {
        width: "100%",
        textAlign: "center",
        fontSize: 16,
        fontFamily: 'SarabunBold',   
        lineHeight: 1.5,
    },
    divRowBoxBlue: {
        backgroundColor: '#F4F8FF',
        marginHorizontal: 30,
        marginVertical: 10,
        paddingHorizontal: 20,        
        paddingVertical: 10,
        display: 'flex',
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: '#D5E3FB',
    },
    boxLeftBlock: {
        textAlign: 'left',
        width: "75%",
        alignItems: 'left',
    },
    boxRightBlock: {
        textAlign: 'right',
        width: "25%",
        alignItems: 'right',
    },
    T14Left: {
        fontFamily: 'SarabunRegular',  
        fontSize: 14,
        width: "100%",
        textAlign: "left",
        color: '#000000',
        lineHeight: 1.5,
    },
    T14RightBold: {
        fontFamily: 'SarabunBold', 
        fontSize: 14,
        width: "100%",
        textAlign: "right",
        color: '#000000',
        lineHeight: 1.5,
    },
    ansBox: {
        padding: 10,
        borderWidth: 1,
        borderColor: '#828282',
        marginHorizontal: 30,
        marginVertical: 10,
        borderRadius: 12,
    },
    image1: {
        paddingTop: 10,
        paddingBottom: 10,
        textAlign: 'center'
    },
    image3: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingHorizontal: 50,
        textAlign: 'center'
    },
    // textText: {
    //     fontFamily: 'SarabunRegular', 
    //     fontSize: 14,      
    //     lineHeight: 1.5,
    //     wordBreak: 'breakAll',
    //     display:'flex',
    //     flexDirection:'row'
    // }

});
export default PdfFile;

